import { api } from '@src/api/api'

export const addressApi = {

  getAddresses() {
    return api.get<string[]>('/v1/addresses-list')
  },
  checkAddress(corpus: string, house: string, street: string) {
    return api.post<boolean>('/v1/send-personal-address', { corpus, house, street })
  },
  changeAddress(account: string, dogovorId: number, address: string, goodName: string) {
    return api.post<boolean>('/v1/user/change-address', {
      account, dogovorId, address, goodName,
    })
  },
}
